import { AdminDetailHeader } from "@/components/header/AdminDetailHeader";
import { userService } from "@/services/user-service";
import { UserDto } from "@/types/dto/user-dto";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { AdminDetailTable } from "../../components/table/admin-detail-table/AdminDetailTable";
import { PageWrapper } from "../../components/wrapper/PageWrapper";

export default function AdminDetailPage() {
  const { id } = useParams();

  const [user, setUser] = useState<UserDto | undefined>(undefined);

  const getUser = async () => {
    try {
      const getAdminById = await userService.getAdminById(Number(id));
      if (!getAdminById.ok) {
        return;
      }
      setUser(getAdminById.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getUser();
  }, [id]);

  return (
    <PageWrapper>
      <div className="flex flex-col w-[1648px] h-full items-between justify-start gap-[16px]">
        <AdminDetailHeader />
        {user && <AdminDetailTable user={user} />}
      </div>
    </PageWrapper>
  );
}
